import { Skeleton } from '@monksflow/monks-ui';

/**
 * Loading placeholder for {@link FileAssetCard}.
 *
 * Mirrors the real card — a 180px preview, the file name, its date and a
 * comment count — so the grid keeps its shape while files load.
 */
export const FileAssetCardSkeleton = () => (
  <div
    data-testid="file-asset-card-skeleton"
    className="flex h-[306px] flex-col overflow-hidden rounded-xl border border-muted bg-card p-1"
  >
    <Skeleton data-testid="skeleton-loader" className="h-[180px] shrink-0 rounded-lg" />

    <div className="flex flex-1 flex-col gap-xs p-md">
      <div className="flex items-start gap-xs">
        <Skeleton data-testid="skeleton-loader" className="h-5 flex-1" />
        <Skeleton data-testid="skeleton-loader" className="size-7 rounded" />
      </div>

      <Skeleton data-testid="skeleton-loader" className="h-4 w-24" />

      <Skeleton data-testid="skeleton-loader" className="mt-auto h-4 w-10" />
    </div>
  </div>
);

FileAssetCardSkeleton.displayName = 'FileAssetCardSkeleton';
